// extracted by mini-css-extract-plugin
export default {"OutlinedButton":"OutlinedButton_OutlinedButton__bqEeI"};